
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/migration/migrating-default-theme",
      function () {
        return require("private-next-pages/joy-ui/migration/migrating-default-theme.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/migration/migrating-default-theme"])
      });
    }
  